import BaseUseCase from "../base_use_case.js";

class CreateTokenUseCase extends BaseUseCase {

  execute(action) {
    return Promise.resolve(grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action }).then(token => token));
  }
}

const instance = new CreateTokenUseCase();
export default instance;